import { constants } from "../../../misc/helpers";
import MainTutorialScenario from "./MainTutorialScenario";

export default class MainTutorialScenarioStep1 {
	constructor(private mainScenario: MainTutorialScenario, private onDone: () => void) {
	}

	public start() {
		this.step1ShowIntro();
	}

	step1ShowIntro() {
		var context = this;
		context.mainScenario.playSound('1', '0', () => {});
		context.mainScenario.gameManager.UiManager.showUi(constants.InGameUINames.PauseMenuTutorial, {
			timer: {
				dispatch: this.mainScenario.gameManager.customData.dispatch,
				penalized: false,
				startTimeInSeconds: 240,
				isActive: true
			}
		});
		this.mainScenario.gameManager.UiManager.showSingleUi(constants.InGameUINames.Start, {
			onClose: () => {
				context.mainScenario.gameManager.UiManager.showSingleUi(constants.InGameUINames.GenericModal, {
					text: "Would you like to return to the main menu?",
					okBttn: {
						text: 'Yes',
						onClick: () => {
							context.mainScenario.showMainMenu();
						}
					},
					cancelBttn: {
						text: 'No',
						onClick: () => {
							context.step1ShowIntro();
						}
					}
				});
			},
			onDone: () => {
				context.step1ASoundIntro();
			}
		});
	}

	step1ASoundIntro() {
		var context = this;
		this.mainScenario.gameManager.UiManager.hideaAllUis();
		context.mainScenario.playSound('1', '1', () => {
			context.step1ShowQuestion();
		});
	}

	step1ShowQuestion() {
		var context = this;
		context.mainScenario.playSound('1', '2', () => {
			context.mainScenario.gameManager.UiManager.showSingleUi(constants.InGameUINames.BinaryQuestion, {
				title: 'Please select the correct answer',
				correctButton: {
					title: 'Correct',
					onClick: () => context.step1BetweenQuestions()
					//onClick: () => context.mainScenario.showCorrectFeedback('This is correct!', () => context.step1BetweenQuestions())
				},
				incorrectButton: {
					title: 'Incorrect',
					greyedOut: true,
					onClick: () => { }
				}
			});
			/*var questionData = {
				title: 'Please select the correct answer',
				disabled: true,
				correctButton: {
					title: 'Correct Answer',
					onClick: () => context.mainScenario.showCorrectFeedback('This is correct!', () => context.step1BShowQuestion())
				},
				incorrectButton: {
					title: 'Incorrect Answer',
					greyedOut: true,
					onClick: () => { }
				}
			};*/
			context.mainScenario.playSound('1', '3', () => {
				//questionData.disabled = false;
				//context.mainScenario.gameManager.UiManager.showUi(constants.InGameUINames.BinaryQuestion, questionData);
			});
			//context.mainScenario.gameManager.UiManager.showUi(constants.InGameUINames.BinaryQuestion, questionData);
		});
	}

	private step1BetweenQuestions() {
		var context = this;
		context.mainScenario.gameManager.UiManager.showSingleUi(constants.InGameUINames.Feedback, {message: 'This is correct!'})
		context.mainScenario.playSound('1', '4', () => {
			this.mainScenario.gameManager.UiManager.hideUi(constants.InGameUINames.Feedback);
			context.step1BShowQuestion()
		});
	}

	step1BShowQuestion() {
		var context = this;
		context.mainScenario.gameManager.UiManager.showSingleUi(constants.InGameUINames.BinaryQuestion, {
			title: 'Please select the incorrect answer',
			correctButton: {
				title: 'Correct',
				greyedOut: true,
				onClick: () => { }
			},
			incorrectButton: {
				title: 'Incorrect',
				onClick: () => context.step1AfterQuestions()
			}
		});
		/*var questionData = {
			title: 'Please select the incorrect answer',
			disabled: true,
			correctButton: {
				title: 'Correct Answer',
				greyedOut: true,
				onClick: () => { }
			},
			incorrectButton: {
				title: 'Incorrect Answer',
				onClick: () => context.mainScenario.showIncorrectFeedback('This is incorrect!', () => context.step1ShowQuestion(), () => context.onDone()) //context.step2RotateCameraNoBystander()
			}
		};*/
		context.mainScenario.playSound('1', '5', () => {
			//questionData.disabled = false;
			//this.mainScenario.gameManager.UiManager.showUi(constants.InGameUINames.BinaryQuestion, questionData);
		});

		//this.mainScenario.gameManager.UiManager.showUi(constants.InGameUINames.BinaryQuestion, questionData);
	}

	private step1AfterQuestions() {
		var context = this;
		context.mainScenario.gameManager.UiManager.showSingleUi(constants.InGameUINames.Feedback, {message: 'This is incorrect!'})
		context.mainScenario.playSound('1', '6', () => {
			this.mainScenario.gameManager.UiManager.hideUi(constants.InGameUINames.Feedback);
			context.step2TryAgain()
		});
	}

	private step2TryAgain() {
		var context = this;
		context.mainScenario.gameManager.UiManager.showSingleUi(constants.InGameUINames.BinaryQuestion, {
			title: 'Would you like to try again?',
			correctButton: {
				title: 'Try Again',
				greyedOut: true,
				onClick: () => { }
			},
			incorrectButton: {
				title: 'Next',
				greyedOut: true,
				onClick: () => { }
			}
		});
		context.mainScenario.playSound('1', '7', () => {
			context.mainScenario.playSound('1', '8', () => {
			});
		});
				context.mainScenario.gameManager.UiManager.hideUi(constants.InGameUINames.BinaryQuestion);
				context.mainScenario.gameManager.UiManager.showSingleUi(constants.InGameUINames.BinaryQuestion, {
					title: 'Would you like to try again?',
					correctButton: {
						title: 'Try Again',
						onClick: () => context.step1ASoundIntro()
					},
					incorrectButton: {
						title: 'Next',
						onClick: () => context.step2TryAgainAfter()
					}

		});
	}

	private step2TryAgainAfter() {
		var context = this;
		context.mainScenario.gameManager.UiManager.hideUi(constants.InGameUINames.BinaryQuestion);
		context.onDone();
	}

}